import ModalWrapper from '../../common/Modal/ModalWrapper'
import Road from '../../dashboard/road'

const WhatYouGetModal = ({ subscription }) => {
    let data = {
        "Free": [
            { card: 'investorMatch', description: 'Number of matches only' },
            { card: 'investorReadiness', description: 'Full report' },
            { card: 'kpiReport', description: 'Full report' },
            { card: 'reasearchAidReport', description: 'Report summaries only' }
        ],
        "Lite": [
            { card: 'investorMatch', description: 'Investor Names' },
            { card: 'investorReadiness', description: 'Full report' },
            { card: 'kpiReport', description: 'Full report' },
            { card: 'reasearchAidReport', description: 'Full report' },
            { card: 'diligencePack', description: 'Slim pack' }
        ],
        "Pro": [
            { card: 'investorFitReport', description: 'Detailed report on each investor' },
            { card: 'investorReadiness', description: 'Full report' },
            { card: 'kpiReport', description: 'Full report' },
            { card: 'reasearchAidReport', description: 'Full report + edit + build your own' },
            { card: 'diligencePack', description: 'Full pack + build your own' },
            { card: 'yourCertification', description: 'Stand out from the crowd' },
            { card: 'investorFitReport', description: '1-Click connections' }
        ]
    }

    let filteredData = { ...data }

    if (subscription === 'Lite') {
        delete filteredData['Free']
    } else if (subscription === 'Pro') {
        delete filteredData['Free']
        delete filteredData['Lite']
    }

    // if subscription is undefined/null/Free → show all (as-is)
    // so no change required in that case

    return (
        <ModalWrapper modalType='whatYouGetModal' modalCardClasses='maw1500px py3rem'>
            <div>
                <h2 className='c15 fs2rem mb2rem tac fw500'>What You Get</h2>
                <div className='px1rem'>
                    {Object.entries(filteredData).map(([keyTitle, items], objIndex) => (
                        <div
                            className={`df fdc br20px p3rem mb3rem ${keyTitle === "Free" && "py6rem"}`}
                            key={`${objIndex}_whatYouGet`}
                            style={{ background: '#D4DBFC' }}
                        >
                            <div className='whatYouGetModalWrapper'>
                                <Road keyTitle={keyTitle} upgradeToPro={["Free", "Lite"].includes(keyTitle)} />
                                <div className='df fdc  jcsb pa' style={{ width: keyTitle === "Free" ? "78%" : '80%', marginLeft: '10%' }}>
                                    <div className='df'>
                                        {items.map((item, index) => {
                                            let cardImage = null;
                                            if (keyTitle === "Free") {
                                                if (item.card === 'investorMatch')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorMatchFree.png`);
                                                else if (item.card === 'investorReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorReadiness.png`);
                                                else if (item.card === 'kpiReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/kpiReport.png`);
                                                else if (item.card === 'reasearchAidReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/researchAidReport.png`);
                                            } else if (keyTitle === "Lite") {
                                                if (item.card === 'investorMatch')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorMatchFree.png`);
                                                else if (item.card === 'investorReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorReadiness.png`);
                                                else if (item.card === 'kpiReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/kpiReport.png`);
                                                else if (item.card === 'reasearchAidReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/researchAidReport.png`);
                                                else if (item.card === 'diligencePack')
                                                    cardImage = require(`../../../../images/whatYouGetModal/diligencePackFree.png`);
                                            } else if (keyTitle === "Pro") {
                                                if (item.card === 'investorMatch')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorMatchPro.png`);
                                                else if (item.card === 'investorReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorReadiness.png`);
                                                else if (item.card === 'kpiReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/kpiReport.png`);
                                                else if (item.card === 'reasearchAidReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/researchAidReport.png`);
                                                else if (item.card === 'diligencePack')
                                                    cardImage = require(`../../../../images/whatYouGetModal/diligencePackPro.png`);
                                                else if (item.card === 'yourCertification')
                                                    cardImage = require(`../../../../images/whatYouGetModal/yourCertificateJourney.png`);
                                                else if (item.card === 'investorFitReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorFitReportPro.png`);
                                            }

                                            return (
                                                <div className='df fdc aic jcc' style={{ maxWidth: '140px' }} key={index}>
                                                    <div className='df aic jcc' style={{ height: '154px' }}>
                                                        <img
                                                            src={cardImage}
                                                            className={keyTitle === "Free" ? "ml2rem" : 'ml1rem '}
                                                            alt='cardImage'
                                                            style={{
                                                                width: cardImage.includes('diligencePackFree') ? '122px' : cardImage.includes('researchAidReport') ? '126px' : cardImage.includes('diligencePackPro') ? '134px' : '120px',
                                                                height: cardImage.includes('diligencePackFree') ? '123px' : cardImage.includes('researchAidReport') ? '128px' : cardImage.includes('diligencePackPro') ? '123px' : 'auto',
                                                                objectFit: 'contain'
                                                            }}

                                                        />
                                                    </div>
                                                    <div className='df fdc aic jcfs' style={{ height: '44px' }}>
                                                        <p className={`c15 fs12px mt0-5rem ${keyTitle === "Free" ? "ml2rem" : 'ml1rem '} tac w100`}>
                                                            {item.description}
                                                        </p>
                                                        {item.description === "1-Click connections" && (
                                                            <img
                                                                style={{ width: '80px' }}
                                                                src={require(`../../../../images/whatYouGetModal/appStoreIcon.png`)}
                                                                alt='appStoreIcon'
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        })}

                                        {keyTitle !== "Free" && (
                                            <div className={`df fdc jcfs aifs ${keyTitle === "Lite" ? 'ml1rem' : 'ml2rem'}`}>
                                                <img style={{ width: '60px', marginTop: '3rem' }} src={require(`../../../../images/whatYouGetModal/locationPin.png`)} alt='locationPin' />
                                                <div className='mt0-5rem'>
                                                    <h3 className='c15 fs1rem'>Pitch for Investment</h3>
                                                    <p className='c15 fs13px'>Confident that you are <br /> investment ready</p>
                                                </div>
                                            </div>
                                        )}

                                        {keyTitle !== "Free" && (
                                            <div className='df fdc jcfs aifs ml3rem bg1 br20px pa shadow' style={{ right: '-60px', top: '-60px', padding: '12px' }}>
                                                <div className='mt1rem'>
                                                    <h3 className='c15 fs1rem fw400'>
                                                        <span className='c3 fs20px fw600'>{keyTitle === "Lite" ? "£8.25" : "£83.25"}</span>/month
                                                    </h3>
                                                    <p className='c15 fs13px op60'>billed annually</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p className='tac w100 c15 fs12px'>* AppStore requires Pro subscription</p>
            </div>
        </ModalWrapper>
    )
}

export default WhatYouGetModal
